import React, { useState, useEffect } from 'react';
import { func, number, bool } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, PATTERNS, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet, useForm } from '@laramie/ui';
import { useFormErrors } from '../../hooks/useFormErrors';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { CompareDates } from '../../../utils/helpers';

import { FormError, Loading, InputEntidad, InputLista, DatePickerCustom, InputEjercicio, FormLabel, Modal } from '../../common';
import { isEmptyString } from '../../../utils/validator';
import { getDateId } from '../../../utils/convert';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import { getDateNow } from '../../../utils/convert';
import {TIPS} from "../../../consts/tips";
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const ExpedienteModal = (props) => {

    //variables
    const entityInit = {
        expediente: {
            id: 0,
            matricula: '',
            ejercicio: '',
            numero: '',
            letra: '',
            idProvincia: 0,
            idTipoExpediente: 0,
            subnumero: '',
            idTemaExpediente: 0,
            referenciaExpediente: '',
            fechaCreacion: null
        },
        archivos: [],
        observaciones: [],
        etiquetas: []
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit,
        showInfo: false
    });
    
    const [processKey, setProcessKey] = useState(null);

    const mount = () => {

        const _processKey = `Expediente_${props.id??0}_${getDateId()}`;
        setProcessKey(_processKey);

        if (props.id > 0) {
            FindExpediente();
        }
        else {
            dispatch(dataTaggerActionSet(_processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
        }
    
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    useEffect(() => {
        if (processKey && state.entity.expediente.id > 0) {
            dispatch(dataTaggerActionSet(processKey, {
                Archivo: state.entity.archivos,
                Observacion: state.entity.observaciones,
                Etiqueta: state.entity.etiquetas
            }));        
        }
    }, [processKey, state.entity]);

    const [ formValues, formHandle, , formSet ] = useForm({
        matricula: '',
        ejercicio: '',
        numero: '',
        letra: '',
        idProvincia: 0,
        idTipoExpediente: 0,
        subnumero: '',
        idTemaExpediente: 0,
        referenciaExpediente: '',
        fechaCreacion: null
    });

    const dispatch = useDispatch();
    const dataTagger = useSelector( (state) => state.dataTagger.data );
    
    //handles
    const handleClickAceptar = () => {
        if (validate()) {
            if (props.id == 0) {
                AddExpediente();
            }
            else {
                ModifyExpediente();
            }
        };
    };
    const handleClickCancelar = () => {
        dispatch(dataTaggerActionClear(processKey));
        props.onDismiss();
    }
    
    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }  
    
    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.matricula.length === 0) errors.matricula = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (formValues.ejercicio.length === 0) errors.ejercicio = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (formValues.numero.length === 0) errors.numero = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (formValues.letra.length === 0) errors.letra = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (formValues.idProvincia <= 0) errors.idProvincia = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idTipoExpediente <= 0) errors.idTipoExpediente = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.fechaCreacion === null) errors.fechaCreacion = VALIDATION_MESSAGE.REQUIRED_DATE;

        if (formValues.fechaCreacion !== null && CompareDates(formValues.fechaCreacion, getDateNow()) > 0) {
            errors.fechaCreacion = 'No puede ser posterior a hoy';
        }

        return errors;
    }

    function getFormatErrors() {

        const errors = {};

        if (props.disabled) return errors;

        if (formValues.ejercicio.length > 0) {
            if (formValues.ejercicio > getDateNow().getFullYear()) errors.ejercicio = 'No puede superar el año actual';
            else if (formValues.ejercicio <= 0) errors.ejercicio = 'Debe ser mayor a cero';
        }

        return errors;
    }

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);
    
    function FindExpediente() {
    
        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                if (data.expediente.fechaCreacion) data.expediente.fechaCreacion = new Date(data.expediente.fechaCreacion);
                data.archivos.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.observaciones.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                
                setState(prevState => {
                  return {...prevState, loading: false, entity: data};
                });
                formSet({
                    matricula: data.expediente.matricula,
                    ejercicio: data.expediente.ejercicio,
                    numero: data.expediente.numero,
                    letra: data.expediente.letra,
                    idProvincia: data.expediente.idProvincia,
                    idTipoExpediente: data.expediente.idTipoExpediente,
                    subnumero: data.expediente.subnumero,
                    idTemaExpediente: data.expediente.idTemaExpediente,
                    referenciaExpediente: data.expediente.referenciaExpediente,
                    fechaCreacion: data.expediente.fechaCreacion                    
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                  return {...prevState, loading: false};
                });
            });
        };
    
        const paramsUrl = `/${props.id}`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EXPEDIENTE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }
    
    function AddExpediente() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveExpediente(method, paramsUrl);
    }
    
    function ModifyExpediente() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SaveExpediente(method, paramsUrl);
    }    

    function SaveExpediente(method, paramsUrl) {

        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
          response.json()
          .then((row) => {
            setState(prevState => {
                return {...prevState, loading: false};
            });
            dispatch(dataTaggerActionClear(processKey));
            props.onConfirm(row.id);
          })
          .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
          });
        };
    
        const dataBody = {
            expediente: {
                ...state.entity.expediente,
                matricula: formValues.matricula,
                ejercicio: formValues.ejercicio,
                numero: formValues.numero,
                letra: formValues.letra,
                idProvincia: parseInt(formValues.idProvincia),
                idTipoExpediente: parseInt(formValues.idTipoExpediente),
                subnumero: formValues.subnumero,
                idTemaExpediente: !isEmptyString(formValues.idTemaExpediente) ? parseInt(formValues.idTemaExpediente) : 0,
                referenciaExpediente: formValues.referenciaExpediente,
                fechaCreacion: formValues.fechaCreacion
            },
            archivos: (dataTagger[processKey]) ? dataTagger[processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[processKey]) ? dataTagger[processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[processKey]) ? dataTagger[processKey].Etiqueta.filter(f => f.state !== 'o') : []
        };
    
        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.EXPEDIENTE,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }

    function ToggleAccordionInfo() {
        setState(prevState => {
            return {...prevState, showInfo: !prevState.showInfo};
        });
    }
    

    const accordionClose = <span className="material-symbols-outlined search-i">chevron_right</span>
    const accordionOpen = <span className="material-symbols-outlined search-i">expand_more</span>

    return (
        <>

        <Loading visible={state.loading}></Loading>

        <Modal
          size="lg"
          title={`Expediente:${(props && props.id > 0) ?
              `${state.entity.expediente.ejercicio}-${state.entity.expediente.numero}-${state.entity.expediente.letra}` :
              " Nuevo"}`}
          tipName={(props && props.id > 0) ?
              TIPS.NAME.MODALS.EXPEDIENTE_MODAL_VIEW :
              TIPS.NAME.MODALS.EXPEDIENTE_MODAL_NUEVO}
          onEscape={() => props.onDismiss()}
          body={(
                <div className="row">

                    <div className="col-6 col-lg-2">
                        <FormLabel htmlFor="ejercicio" required>Ejercicio</FormLabel>
                        <InputEjercicio
                            name="ejercicio"
                            placeholder=""
                            className={`form-control ${errorOf('ejercicio') ? 'is-invalid' : ''}`}
                            value={ formValues.ejercicio }
                            onChange={ formHandle }
                            disabled={props.disabled}
                            max={getDateNow().getFullYear()}
                        />
                        <FormError message={errorOf('ejercicio')} />
                    </div>

                    <div className="col-6 col-lg-2">
                        <FormLabel htmlFor="numero" required>Número</FormLabel>
                        <input
                            name="numero"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('numero') ? 'is-invalid' : ''}`}
                            value={ formValues.numero }
                            onChange={({target}) =>{
                                if (target.validity.valid) {
                                    formSet({...formValues, numero: target.value});
                                }
                            }}
                            disabled={props.disabled} 
                            pattern={PATTERNS.onlyNumbers}
                            maxLength="50"                          
                        />
                        <FormError message={errorOf('numero')} />
                    </div>

                    <div className="col-6 col-lg-2">
                        <FormLabel htmlFor="letra" required>Letra</FormLabel>
                        <input
                            name="letra"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('letra') ? 'is-invalid' : ''}`}
                            value={ formValues.letra }
                            onChange={({target}) =>{
                                if (target.validity.valid) {
                                    formSet({...formValues, letra: target.value});
                                }
                            }}
                            disabled={props.disabled}  
                            pattern={PATTERNS.onlyLetters}
                            maxLength="50"                          
                        />
                        <FormError message={errorOf('letra')} />
                    </div>


                    <div className="col-6 col-lg-2">
                        <label htmlFor="subnumero" className="form-label">Sub número</label>
                        <input
                            name="subnumero"
                            type="text"
                            placeholder=""
                            className="form-control"
                            value={ formValues.subnumero }
                            onChange={ formHandle }
                            disabled={props.disabled}  
                            maxLength="50"
                        />
                        <FormError />
                    </div>

                    <div className="col-6 col-lg-2">
                        <FormLabel htmlFor="matricula" required>Matrícula</FormLabel>
                        <input
                            name="matricula"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('matricula') ? 'is-invalid' : ''}`}
                            value={ formValues.matricula }
                            onChange={ formHandle }
                            disabled={props.disabled}  
                            maxLength="50"                          
                        />
                        <FormError message={errorOf('matricula')} />
                    </div>

                    <div className="col-12 col-lg-4">
                        <FormLabel htmlFor="idProvincia" required>Provincia</FormLabel>
                        <InputEntidad
                            name="idProvincia"
                            placeholder=""
                            className={`form-control ${errorOf('idProvincia') ? 'is-invalid' : ''}`}
                            value={ formValues.idProvincia }
                            onChange={ formHandle }
                            disabled={props.disabled}
                            title="Provincia"
                            entidad="Provincia"
                            tipName={TIPS.NAME.MODALS.PROVINCIA_MODAL}
                        />
                        <FormError message={errorOf('idProvincia')} />
                    </div>

                    <div className="col-6 col-lg-4">
                        <FormLabel htmlFor="fechaCreacion" required>Fecha de creación</FormLabel>
                        <DatePickerCustom
                            name="fechaCreacion"
                            placeholder=""
                            className={`form-control ${errorOf('fechaCreacion') ? 'is-invalid' : ''}`}
                            value={ formValues.fechaCreacion }
                            onChange={ formHandle }
                            disabled={props.disabled}
                            maxValue={getDateNow()}
                        />
                        <FormError message={errorOf('fechaCreacion')} />
                    </div>

                    <div className="col-12 col-lg-4">
                        <FormLabel htmlFor="idTipoExpediente" required>Tipo de expediente</FormLabel>
                        <InputLista
                            name="idTipoExpediente"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoExpediente') ? 'is-invalid' : ''}`}
                            value={ formValues.idTipoExpediente }
                            onChange={ formHandle }
                            disabled={props.disabled}
                            lista="TipoExpediente"
                        />
                        <FormError message={errorOf('idTipoExpediente')} />
                    </div>
                    
                    <div className="col-12">
                        <label htmlFor="idTemaExpediente" className="form-label">Tema de expediente</label>
                        <InputEntidad
                            name="idTemaExpediente"
                            placeholder=""
                            className="form-control"
                            value={ formValues.idTemaExpediente }
                            onChange={ formHandle }
                            disabled={props.disabled}
                            title="Tema de expediente"
                            entidad="TemaExpediente"
                            tipName={TIPS.NAME.MODALS.TEMA_EXPEDIENTE_MODAL}
                        />
                        <FormError />
                    </div>

                    <div className="mb-3 col-12">
                        <div className='accordion-header'>
                            <div className='row'>
                                <div className="col-12" onClick={() => ToggleAccordionInfo()}>
                                    <div className='accordion-header-title'>
                                        {(state.showInfo) ? accordionOpen : accordionClose}
                                        <h3 className={state.showInfo ? 'active' : ''}>Información adicional</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {state.showInfo &&
                        <div className='accordion-body'>
                            <DataTaggerFormRedux
                                title="Información adicional de expediente"
                                processKey={processKey}
                                entidad="Expediente"
                                idEntidad={props.id}
                                disabled={props.disabled}
                            />
                        </div>
                        }
                    </div>

                </div>
          )}
          footer={!props.disabled ? (<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
          </>) : (
                <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
          )}
          footerClassName={props.disabled ? 'f-align' : ''}
        />

        </>
      );
    }
    

ExpedienteModal.propTypes = {
    id: number.isRequired,
    disabled: bool,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired
};

ExpedienteModal.defaultProps = {
    disabled: false
};    

export default ExpedienteModal;
